import { useSelector } from 'react-redux';
import { Card } from 'components/v4/Card';
import { VStack } from '@chakra-ui/react';
import {
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Button,
    Text,
} from 'components/v4';
import Image from 'components/v4/Image';

import CardDetails from '../components/CardDetails';
import { OPERATOR_PLATFORM } from '../constants';

const walkthroughIdModal = {
    ufCancelButton: '/services-profile-add/modal/confirmation/cancel',
    ufAddButton: '/services-profile-add/modal/confirmation/add',
};

const ConfirmationModal = ({
    onClose,
    isOpen,
    vendorDefined,
    handleSubmit,
    serviceProfile,
}) => {
    const { colorScheme } = useSelector((state) => state.settings);
    const { darkMode } = useSelector((state) => state.settings);
    return (
        <Modal
            closeOnOverlayClick={false}
            isCentered
            isOpen={isOpen}
            onClose={onClose}
            size="md">
            <ModalOverlay backdropFilter="blur(10px)" />
            <ModalContent as="form" onSubmit={handleSubmit}>
                <Card
                    bg={darkMode ? 'dark.tcap' : null}
                    borderRadius={10}
                    key={`addcard/${serviceProfile?.serviceType}`}
                    data-walkthroughid={`addcard/${serviceProfile?.serviceType}`}>
                    <ModalHeader className="flex items-center justify-center">
                        <VStack className="flex items-center">
                            <Image
                                className="mr-2 rounded-xl"
                                src={
                                    CardDetails(serviceProfile.serviceType)
                                        ?.icon
                                }
                                boxSize="50px"
                                objectFit="contain"
                            />
                            <Text>
                                {
                                    CardDetails(serviceProfile.serviceType)
                                        ?.serviceName
                                }
                            </Text>
                        </VStack>
                    </ModalHeader>
                    <ModalBody>
                        <p className="text-base">
                            {vendorDefined &&
                            serviceProfile?.serviceType !== OPERATOR_PLATFORM
                                ? serviceProfile.serviceDefinition?.name
                                : CardDetails(serviceProfile.serviceType)
                                      ?.addDescription}
                        </p>
                    </ModalBody>
                    <ModalFooter className="flex justify-center">
                        <Button
                            type="button"
                            variant="outline"
                            className="secondary mr-4 !w-full"
                            onClick={onClose}
                            data-walkthroughid={
                                walkthroughIdModal.ufCancelButton
                            }>
                            Cancel
                        </Button>
                        <Button
                            bg={`${colorScheme}.500`}
                            _hover={{
                                bg: `${colorScheme}.600`,
                            }}
                            className={`flex min-h-[38px] !w-full items-center justify-center rounded-md px-3 py-1.5 text-base font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--chakra-colors-${colorScheme}-600)]`}
                            type="submit"
                            data-walkthroughid={walkthroughIdModal.ufAddButton}>
                            Confirm
                        </Button>
                    </ModalFooter>
                </Card>
            </ModalContent>
        </Modal>
    );
};

export default ConfirmationModal;
